import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './Admin.css';

interface Stats {
  totalUsers: number;
  activeWarranties: number;
  expiredWarranties: number;
  pendingClaims: number;
  approvedClaims: number;

}

const AdminDashboard: React.FC = () => {
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get('/api/admin/dashboard');
      setStats(response.data.stats);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="loading">Loading...</div>
      </>
    );
  }

  if (!stats) return null;



  return (
    <>
      <Navbar />
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h1 className="page-title" style={{ marginBottom: 0 }}>📊 Admin Dashboard</h1>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <h3>Total Users</h3>
            <p className="stat-value">{stats.totalUsers}</p>
          </div>
          <div className="stat-card">
            <h3>Active Warranties</h3>
            <p className="stat-value">{stats.activeWarranties}</p>
          </div>
          <div className="stat-card">
            <h3>Expired Warranties</h3>
            <p className="stat-value">{stats.expiredWarranties}</p>
          </div>
          <div className="stat-card">
            <h3>Pending Claims</h3>
            <p className="stat-value">{stats.pendingClaims}</p>
            <Link to="/admin/claims?status=pending" className="btn btn-primary">
              View
            </Link>
          </div>
          <div className="stat-card">
            <h3>Approved Claims</h3>
            <p className="stat-value">{stats.approvedClaims}</p>
          </div>


        </div>
        <div className="quick-actions">
          <Link to="/admin/warranties" className="btn btn-primary">
            Manage Warranties
          </Link>
          <Link to="/admin/claims" className="btn btn-primary">
            Manage Claims
          </Link>

          <Link to="/admin/users" className="btn btn-primary">
            Manage Users
          </Link>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;

